import React, { Fragment, useState } from 'react';
import AllOutcomes from 'apps/journey/components/modals/outcomes/all-outcomes';
import styled from 'styled-components';
import { capitalize } from 'library/helpers/text';
import InputField from 'apps/journey/components/input-field';
import { func, number, string } from 'prop-types';
import withConfig from 'util/hoc/with-config';
import { resolve } from 'library/helpers/path-resolver';
import * as StyledOutcomesModal from 'apps/journey/components/modals/outcomes/styled-outcomes-modal';
import { withRouter } from 'library/util/core-router';
import { handleCancel } from 'apps/journey/components/modals/outcomes/util/handle-cancel';

const SearchWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 1em;
  position: relative;
  width: 100%;

  div {
    width: 50%;
  }

  @media (max-width: 735px) {
    div {
      width: 100%;
    }
  }
`;

const AllOutcomesBody = ({ actionButtonText, configuration, ...props }) => {
  const [values, setValues] = useState({});
  const namespace = {};

  const handleChange = () => {
    const {
      target: { name, value },
    } = namespace.event;
    setValues((values) => ({ ...values, [name]: value }));
  };

  const doSearch = (e) => {
    clearTimeout(namespace.searchtimeout);
    e.persist();
    namespace.event = e;
    namespace.searchtimeout = setTimeout(handleChange, 300);
  };

  return (
    <Fragment>
      <p className="recommendationDescription">
        {props.headerDescription
          ? props.headerDescription
          : `Choose what ${resolve(
              configuration,
              'environment/journey/goals_name',
              'Outcome'
            )}s you would like to set for yourself.  New ${resolve(
              configuration,
              'environment/journey/goals_name',
              'Outcome'
            )}s will be added to the top of your list.`}
      </p>
      <SearchWrapper>
        <InputField
          name="searchValue"
          label={`Search for an ${resolve(
            configuration,
            'environment/journey/goals_name',
            'Outcome'
          )}...`}
          type="text"
          onChange={doSearch}
        />
      </SearchWrapper>
      <AllOutcomes
        doSearch={doSearch}
        searchValue={values.searchValue}
        {...props}
      />
      <StyledOutcomesModal.Footer canSubmit={true}>
        <button
          aria-label={`Close the ${resolve(
            configuration,
            'environment/journey/goals_name',
            'outcome'
          )} Modal`}
          type="button"
          className="cancelButton"
          onClick={() => handleCancel(props)}
        >
          Cancel
        </button>
        <button type="button" className="confirmButton" disabled>
          {actionButtonText
            ? actionButtonText
            : `Add ${capitalize(
                resolve(
                  configuration,
                  'environment/journey/goals_name',
                  'outcome'
                )
              )}`}
        </button>
      </StyledOutcomesModal.Footer>
    </Fragment>
  );
};

AllOutcomesBody.propTypes = {
  renderOutcomeCard: func,
  activeOutcomeId: number,
  headerDescription: string,
  actionButtonText: string,
};

export default withRouter(withConfig(AllOutcomesBody));
